import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { routerActions } from 'connected-react-router';
import { Loc } from 'redux-react-i18n';
import { Switch, Route } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import ContentSimpleGrid from '../../components/Filters/ContentSimpleGrid';
import Slider from '../../components/Slider';
import PageTitle from '../../components/PageTitle';
import MediasCarousel from '../../components/Carousels/MediasCarousel';
import ContentFilter from '../../components/Filters/ContentFilter';
import CartoonDetailsPage from './CartoonDetailsPage';
import * as slidersActions from '../../actions/slidersActions';
import * as cartoonsActions from '../../actions/cartoonsActions';
import * as mediaDetailsActions from '../../actions/mediaDetailsActions';

class CartoonsPage extends React.Component {
  static propTypes = {
    // Actions
    routerActions: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    slidersActions: PropTypes.shape({
      getCartoonsSlides: PropTypes.func,
    }).isRequired,
    cartoonsActions: PropTypes.shape({
      getCartoonsFilter: PropTypes.func,
      getFilteredCartoons: PropTypes.func,
      clearFilteredCartoons: PropTypes.func,
      getNewCartoons: PropTypes.func.isRequired,
      getLastCartoons: PropTypes.func.isRequired,
      getTopCartoons: PropTypes.func.isRequired,
      getRecommendedCartoons: PropTypes.func.isRequired,
    }).isRequired,
    mediaDetailsActions: PropTypes.shape({
      getMediaDetails: PropTypes.func.isRequired,
    }).isRequired,

    // Data
    currentLanguage: PropTypes.string.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    cartoonsSlidersData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    cartoonsData: PropTypes.shape({
      new: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.arrayOf(PropTypes.object),
      }),
    }).isRequired,
    contentDetails: PropTypes.shape({
      mediaDetails: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.objectOf(PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.string,
          PropTypes.number,
          PropTypes.array,
          PropTypes.object,
        ])),
      }),
    }).isRequired,
    filterData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.objectOf(PropTypes.array),
    }).isRequired,
    filteredCartoonsData: PropTypes.shape({
      status: PropTypes.number,
      pageLoaded: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
  };

  constructor() {
    super();

    this.state = {
      genresIds: [],
      countriesIds: [],
      yearsIds: [],
      languagesIds: [],
      resetPageCounter: false,
    };

    this.formHandler = this.formHandler.bind(this);
    this.resetBtnHandler = this.resetBtnHandler.bind(this);
    this.genresCheckboxHandler = this.genresCheckboxHandler.bind(this);
    this.countriesCheckboxHandler = this.countriesCheckboxHandler.bind(this);
    this.yearsCheckboxHandler = this.yearsCheckboxHandler.bind(this);
    this.languagesCheckboxHandler = this.languagesCheckboxHandler.bind(this);
    this.filteredContentLoadHandler = this.filteredContentLoadHandler.bind(this);
    this.newCartoonsLoadHandler = this.newCartoonsLoadHandler.bind(this);
    this.lastCartoonsLoadHandler = this.lastCartoonsLoadHandler.bind(this);
    this.topCartoonsLoadHandler = this.topCartoonsLoadHandler.bind(this);
    this.recommendedCartoonsLoadHandler = this.recommendedCartoonsLoadHandler.bind(this);
  }

  resetBtnHandler() {
    this.props.routerActions.push('/cartoons');
    this.setState({
      genresIds: [],
      countriesIds: [],
      yearsIds: [],
      languagesIds: [],
    });
  }

  formHandler() {
    if (this.props.location.pathname !== '/cartoons/filtered') {
      this.props.routerActions.push('/cartoons/filtered');
    }
  }

  genresCheckboxHandler(e) {
    const currentTarget = e.target;

    this.props.cartoonsActions.clearFilteredCartoons();
    this.setState({
      resetPageCounter: true,
    });

    const { genresIds } = this.state;

    if (genresIds.indexOf(currentTarget.value) !== -1) {
      this.setState({
        genresIds: genresIds.filter(genre => genre !== currentTarget.value),
      });
    } else {
      this.setState(prevState => ({ genresIds: [...prevState.genresIds, currentTarget.value] }));
    }
  }

  countriesCheckboxHandler(e) {
    const currentTarget = e.target;

    this.props.cartoonsActions.clearFilteredCartoons();
    this.setState({
      resetPageCounter: true,
    });

    const { countriesIds } = this.state;

    if (countriesIds.indexOf(currentTarget.value) !== -1) {
      this.setState({
        countriesIds: countriesIds.filter(country => country !== currentTarget.value),
      });
    } else {
      this.setState(prevState => ({
        countriesIds: [...prevState.countriesIds, currentTarget.value],
      }));
    }
  }

  yearsCheckboxHandler(e) {
    const currentTarget = e.target;

    this.props.cartoonsActions.clearFilteredCartoons();
    this.setState({
      resetPageCounter: true,
    });

    const { yearsIds } = this.state;

    if (yearsIds.indexOf(currentTarget.value) !== -1) {
      this.setState({
        yearsIds: yearsIds.filter(year => year !== currentTarget.value),
      });
    } else {
      this.setState(prevState => ({ yearsIds: [...prevState.yearsIds, currentTarget.value] }));
    }
  }

  languagesCheckboxHandler(e) {
    const currentTarget = e.target;

    this.props.cartoonsActions.clearFilteredCartoons();
    this.setState({
      resetPageCounter: true,
    });

    const { languagesIds } = this.state;

    if (languagesIds.indexOf(currentTarget.value) !== -1) {
      this.setState({
        languagesIds: languagesIds.filter(language => language !== currentTarget.value),
      });
    } else {
      this.setState(prevState => ({
        languagesIds: [...prevState.languagesIds, currentTarget.value],
      }));
    }
  }

  filteredContentLoadHandler(pageNum) {
    const {
      genresIds,
      countriesIds,
      yearsIds,
      languagesIds,
    } = this.state;

    if (this.state.resetPageCounter) {
      this.setState({
        resetPageCounter: false,
      });
    }

    this.props.cartoonsActions.getFilteredCartoons(
      pageNum,
      genresIds,
      countriesIds,
      yearsIds,
      languagesIds,
    );
  }

  newCartoonsLoadHandler(page) {
    this.props.cartoonsActions.getNewCartoons(page);
  }

  lastCartoonsLoadHandler(page) {
    this.props.cartoonsActions.getLastCartoons(page);
  }

  topCartoonsLoadHandler(page) {
    this.props.cartoonsActions.getTopCartoons(page);
  }

  recommendedCartoonsLoadHandler(page) {
    this.props.cartoonsActions.getRecommendedCartoons(page);
  }

  render() {
    const {
      currentLanguage,
      cartoonsData,
      cartoonsSlidersData,
      contentDetails,
      filterData,
      filteredCartoonsData,
    } = this.props;

    const {
      genresIds,
      countriesIds,
      yearsIds,
      languagesIds,
    } = this.state;

    const checkedData = {
      genresIds,
      countriesIds,
      yearsIds,
      languagesIds,
    };

    return (
      <React.Fragment>
        <Switch>
          <Route path="/cartoons/cartoon/:id" component={CartoonDetailsPage} />
          <React.Fragment>
            {/* Filter */}
            <ContentFilter
              title={<Loc locKey="cartoonsGenres" />}
              getFilter={this.props.cartoonsActions.getCartoonsFilter}
              filterData={filterData}
              currentLanguage={currentLanguage}
              formHandler={this.formHandler}
              checkedData={checkedData}
              resetBtnHandler={this.resetBtnHandler}
              genresCheckboxHandler={this.genresCheckboxHandler}
              countriesCheckboxHandler={this.countriesCheckboxHandler}
              yearsCheckboxHandler={this.yearsCheckboxHandler}
              languagesCheckboxHandler={this.languagesCheckboxHandler}
            />

            <Route
              path="/cartoons/filtered"
              render={
                () => (
                  <ContentSimpleGrid
                    itemRoute="cartoon"
                    contentData={filteredCartoonsData}
                    resetPageCounter={this.state.resetPageCounter}
                    handleInfiniteLoad={this.filteredContentLoadHandler}
                    currentLanguage={this.props.currentLanguage}
                  />
                )
              }
            />

            <Route
              path="/cartoons/new"
              render={
                () => (
                  <React.Fragment>
                    <PageTitle level={2}>
                      <Loc locKey="new" />
                    </PageTitle>
                    <ContentSimpleGrid
                      itemRoute="cartoon"
                      contentData={cartoonsData.new}
                      resetPageCounter={this.state.resetPageCounter}
                      handleInfiniteLoad={this.newCartoonsLoadHandler}
                      currentLanguage={currentLanguage}
                    />
                  </React.Fragment>
                )
              }
            />

            <Route
              path="/cartoons/last"
              render={
                () => (
                  <React.Fragment>
                    <PageTitle level={2}>
                      <Loc locKey="last" />
                    </PageTitle>
                    <ContentSimpleGrid
                      itemRoute="cartoon"
                      contentData={cartoonsData.last}
                      resetPageCounter={this.state.resetPageCounter}
                      handleInfiniteLoad={this.lastCartoonsLoadHandler}
                      currentLanguage={currentLanguage}
                    />
                  </React.Fragment>
                )
              }
            />

            <Route
              path="/cartoons/top"
              render={
                () => (
                  <React.Fragment>
                    <PageTitle level={2}>
                      <Loc locKey="top" />
                    </PageTitle>
                    <ContentSimpleGrid
                      itemRoute="cartoon"
                      contentData={cartoonsData.top}
                      resetPageCounter={this.state.resetPageCounter}
                      handleInfiniteLoad={this.topCartoonsLoadHandler}
                      currentLanguage={currentLanguage}
                    />
                  </React.Fragment>
                )
              }
            />

            <Route
              path="/cartoons/recommended"
              render={
                () => (
                  <React.Fragment>
                    <PageTitle level={2}>
                      <Loc locKey="recommended" />
                    </PageTitle>
                    <ContentSimpleGrid
                      itemRoute="cartoon"
                      contentData={cartoonsData.recommended}
                      resetPageCounter={this.state.resetPageCounter}
                      handleInfiniteLoad={this.recommendedCartoonsLoadHandler}
                      currentLanguage={currentLanguage}
                    />
                  </React.Fragment>
                )
              }
            />

            <Route
              exact
              path="/cartoons"
              render={
                () => (
                  <React.Fragment>
                    {/* Cartoons slider */}
                    <LazyLoad height={400} once debounce={50}>
                      <Slider
                        getSlides={this.props.slidersActions.getCartoonsSlides}
                        data={cartoonsSlidersData.data}
                        accentColor="#6ab"
                        currentLanguage={currentLanguage}
                      />
                    </LazyLoad>

                    {/* New Cartoons container */}
                    <LazyLoad height={350} once debounce={50}>
                      <MediasCarousel
                        title={<Loc locKey="new" />}
                        buttonContent={<Loc locKey="watchAll" />}
                        titleRoute="cartoons/new"
                        itemRoute="cartoons/cartoon"
                        coverOrientation="landscape"
                        getMedias={this.props.cartoonsActions.getNewCartoons}
                        getMediaDetails={this.props.mediaDetailsActions.getMediaDetails}
                        mediasData={cartoonsData.new}
                        mediaDetailsData={contentDetails.mediaDetails}
                        currentLanguage={currentLanguage}
                      />
                    </LazyLoad>

                    {/* Last Cartoons container */}
                    <LazyLoad height={350} once debounce={50}>
                      <MediasCarousel
                        title={<Loc locKey="last" />}
                        buttonContent={<Loc locKey="watchAll" />}
                        titleRoute="cartoons/last"
                        itemRoute="cartoons/cartoon"
                        coverOrientation="landscape"
                        getMedias={this.props.cartoonsActions.getLastCartoons}
                        getMediaDetails={this.props.mediaDetailsActions.getMediaDetails}
                        mediasData={cartoonsData.last}
                        mediaDetailsData={contentDetails.mediaDetails}
                        currentLanguage={currentLanguage}
                      />
                    </LazyLoad>

                    {/* Top Cartoons container */}
                    <LazyLoad height={350} once debounce={50}>
                      <MediasCarousel
                        title={<Loc locKey="top" />}
                        buttonContent={<Loc locKey="watchAll" />}
                        titleRoute="cartoons/top"
                        itemRoute="cartoons/cartoon"
                        coverOrientation="landscape"
                        getMedias={this.props.cartoonsActions.getTopCartoons}
                        getMediaDetails={this.props.mediaDetailsActions.getMediaDetails}
                        mediasData={cartoonsData.top}
                        mediaDetailsData={contentDetails.mediaDetails}
                        currentLanguage={currentLanguage}
                      />
                    </LazyLoad>

                    {/* Recommended Cartoons container */}
                    <LazyLoad height={350} once debounce={50}>
                      <MediasCarousel
                        title={<Loc locKey="recommended" />}
                        buttonContent={<Loc locKey="watchAll" />}
                        titleRoute="cartoons/recommended"
                        itemRoute="cartoons/cartoon"
                        coverOrientation="landscape"
                        getMedias={this.props.cartoonsActions.getRecommendedCartoons}
                        getMediaDetails={this.props.mediaDetailsActions.getMediaDetails}
                        mediasData={cartoonsData.recommended}
                        mediaDetailsData={contentDetails.mediaDetails}
                        currentLanguage={currentLanguage}
                      />
                    </LazyLoad>
                  </React.Fragment>
                )
              }
            />
          </React.Fragment>
        </Switch>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.i18n.currentLanguage,
    cartoonsSlidersData: state.sliders.cartoons,
    cartoonsData: state.cartoons,
    contentDetails: state.contentDetails,
    filterData: state.cartoons.availableFilters,
    filteredCartoonsData: state.cartoons.filteredData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    slidersActions: bindActionCreators(slidersActions, dispatch),
    cartoonsActions: bindActionCreators(cartoonsActions, dispatch),
    mediaDetailsActions: bindActionCreators(mediaDetailsActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CartoonsPage);
